export const styles = (theme) => ({
  mainGrid: {
    marginTop: '112px',
    marginLeft: '10px',
    marginRight: '10px'
  },
  mainLoading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '150px'
  },
  redirectingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    height: '150px'
  },
  messageContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '150px'
  },
  textField: {
    '& > div::before': {
      borderBottom: 'none'
    }
  },
  buttonContainer: {
    display: 'flex',
    marginTop: '50px',
    justifyContent: 'start'
  },
  btn_margin: {
    margin: '10px'
  }
});
